import { render, staticRenderFns } from "./CopyTemplate.vue?vue&type=template&id=2bd61eec&scoped=true"
import script from "./CopyTemplate.vue?vue&type=script&lang=js"
export * from "./CopyTemplate.vue?vue&type=script&lang=js"
import style0 from "./CopyTemplate.vue?vue&type=style&index=0&id=2bd61eec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd61eec",
  null
  
)

export default component.exports